"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsEscalationEventTable = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireWildcard(require("react"));
var _dmsbasereact = require("dmsbasereact");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsEscalationEventTable = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("Instance").d("Instance"),
    column_name: "instance_pk",
    control: 'select',
    url: "/escalation_instance/all"
  }, {
    label: _reactIntlUniversal.default.get("EscalationLevel").d("Escalation Level"),
    column_name: "escalation_level",
    control: 'select',
    url: "/escalation_level/all"
  }, {
    label: _reactIntlUniversal.default.get("TriggedAt").d("Trigged At"),
    column_name: "triggered_at",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("NotifiedUser").d("Notified User"),
    column_name: "notified_user_pk",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("EventType").d("Event Type"),
    column_name: "event_type",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("EventDetails").d("Event Details"),
    column_name: "event_details",
    filter: true
  }];
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: "/escalation_event/table",
    export_table: false,
    responsive: true
  });
};
exports.DmsEscalationEventTable = DmsEscalationEventTable;